<p *ngIf="!answer?.extra || answer?.value === 'N/A'; else sliderTmpl" class="mb-0">{{ answer?.value }}</p>

<ng-template #sliderTmpl>
  <p>
    {{ answer?.value }} ({{'map.popup.RANGESCALE' | translate}} {{answer?.extra.scaleMin}} - {{answer?.extra.scaleMax}})
  </p>
</ng-template>